import { Button, ExternalLinkIcon } from '@buffer-mono/popcorn'

import styles from './MentionDeepLinkButton.module.css'

import type { JSX } from 'react'

type MentionDeepLinkButtonProps = {
  /** URL to open on the third-party platform. */
  href: string
  /**
   * Capability-provided label. Defaults to "Open Thread"; individual
   * services can override in the capability matrix (e.g. YouTube →
   * "Go to YouTube"). Most partial-post services (e.g. Mastodon) keep
   * the default.
   */
  label: string
}

/**
 * Deep-link button rendered next to the prefix when the experience is
 * partial — notify-only comment mentions (e.g. Instagram / Facebook)
 * or partial-post mentions (e.g. YouTube, Mastodon). Visibility is
 * decided by the parent (`MentionCard`); this component is the
 * render-only piece.
 */
export const MentionDeepLinkButton = ({
  href,
  label,
}: MentionDeepLinkButtonProps): JSX.Element => {
  return (
    <Button
      as="a"
      variant="secondary"
      size="small"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.button}
    >
      <ExternalLinkIcon />
      {label}
    </Button>
  )
}

MentionDeepLinkButton.displayName = 'MentionDeepLinkButton'
